import Marionette from 'backbone.marionette';
import journalEventBillListviewTmpl from '../templates/journal_event_bill_listview.tpl';
import journalEventBillItemview from './journal_event_bill_itemview';
export default Marionette.CompositeView.extend({
  template: journalEventBillListviewTmpl,
  childView: journalEventBillItemview,
  childViewContainer: "dl.event-bill-list",
  tagName: "div",
  initialize: function () {
    this.collection = this.model.get("bills");
  }
});